import {useEffect, useState} from 'react';
import {getLangCode, stringBundle} from '../stringBundle';

const useLocalizedStringBundle = () => {
  const [localizedStringBundle, setLocalizedStringBundle] = useState({});

  useEffect(() => {
    setLocalizedStringBundle(stringBundle(getLangCode(), () => {}));
  }, []);

  return localizedStringBundle;
};

export default useLocalizedStringBundle;
